export default "__VITE_ASSET__B8tF_V6h__"